<template>
  <FieldDashboard role="driver" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import FieldDashboard from "@/components/Dashboard/FieldDashboard.vue";

// Livreur dashboard (role_id 4): see components/Dashboard/FieldDashboard.vue
export default defineComponent({
  components: { FieldDashboard },
});
</script>
